// extracted by mini-css-extract-plugin
module.exports = {"heading":"TermsOfServicePage_heading__35HXw","content":"TermsOfServicePage_content__3V8Xr"};